import React from 'react';

const Card = ({ children, onClick }) => {
  return (
    <div className="card" onClick={onClick} style={{padding:'1.25rem'}}>
      {children}
    </div>
  );
};
export default Card;
